import {AnimationGlobalEnum} from './animation-global.enum';

//#region ENUM AnimationDirectionEnum

/**
 * ### AnimationDirectionEnum
 * Enum representing possible values for the CSS `animation-direction` property.
 *
 * This enum is accompanied by:
 * - `AnimationDirectionEnumHumanReadable` — human-friendly labels.
 * - `AnimationDirectionEnumType` — a union type of all enum keys.
 *
 * @enum AnimationDirectionEnum
 * @property ALTERNATE - The animation reverses direction each cycle.
 * @property ALTERNATE_REVERSE - The animation starts in reverse and alternates direction each cycle.
 * @property NORMAL - The animation plays forward on each cycle.
 * @property REVERSE - The animation plays in reverse on each cycle.
 */
export enum AnimationDirectionEnum {
  /** The animation reverses direction each cycle. */
  ALTERNATE = 'alternate',

  /** The animation starts in reverse and alternates direction each cycle. */
  ALTERNATE_REVERSE = 'alternate-reverse',

  /** The animation plays forward on each cycle. */
  NORMAL = 'normal',

  /** The animation plays in reverse on each cycle. */
  REVERSE = 'reverse',
}

//#endregion

//#region TYPE AnimationDirectionEnumType
/**
 * ### AnimationDirectionEnumType
 * Union type of all keys in `AnimationDirectionEnum`.
 *
 * @type AnimationDirectionEnumType
 * @example
 * // Possible values: 'ALTERNATE' | 'ALTERNATE_REVERSE' | 'NORMAL' | 'REVERSE'
 */
export type AnimationDirectionEnumType = keyof typeof AnimationDirectionEnum;
//#endregion

//#region TYPE AnimationDirectionType
/**
 * ### AnimationDirectionType
 * Union type of all keys from `AnimationDirectionEnum` and `AnimationGlobalEnum`.
 *
 * This type is useful when a value can be either a direction-specific or global animation keyword.
 *
 * @type AnimationDirectionType
 * @example
 * // Possible values:
 * // 'ALTERNATE' | 'ALTERNATE_REVERSE' | 'NORMAL' | 'REVERSE'
 * // | 'INHERIT' | 'INITIAL' | 'REVERT' | 'REVERT_LAYER' | 'UNSET'
 */
export type AnimationDirectionType =
  | keyof typeof AnimationDirectionEnum
  | keyof typeof AnimationGlobalEnum;
//#endregion
